import { Component } from '@angular/core';

@Component({
  templateUrl: './quickstart-hierarchies-overview.component.html',
  styleUrls: ['./quickstart-hierarchies-overview.component.scss'],
  standalone: false,
})
export class QuickstartHierarchiesOverviewComponent {}
